import { AfterContentChecked, ChangeDetectorRef, Component, EventEmitter, Input, OnInit } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { WebStorageService } from '@app/_core/services/webstorage.service';
import { BsModalRef } from 'ngx-bootstrap/modal';
@Component({
  selector: 'app-filter-dialog',
  templateUrl: './filter-dialog.component.html',
  styleUrls: ['./filter-dialog.component.scss'],
})
export class FilterDialogComponent implements OnInit, AfterContentChecked {
  /*@Input()
  filterVals: any;*/
  @Input()
  colName: any;
  @Input()
  cols: any;
  // @Input()
  // filteredValue:any;
  form!: FormGroup;
  filterVals: any = [];
  noData: boolean = false;
  nullLabel: string = '(no value)';
  public event: EventEmitter<any> = new EventEmitter();
  constructor(
    private cdr: ChangeDetectorRef,
    public bsModalRef: BsModalRef,
    private formBuilder: FormBuilder,
    private webStorageService: WebStorageService
  ) {
    this.form = this.formBuilder.group({
      filters: this.formBuilder.array([]),
    });
  }

  ngOnInit() {
    if(this.colName == 'CaseOwner') this.nullLabel = 'Unassigned';
    // console.log('colName', this.colName, this.cols);
    for (const col of this.cols) {
      if (col.name == this.colName || col.label == this.colName) {
        // if(this.filteredValue && this.filteredValue.length > 0){
        //   col.filterVals = this.filteredValue
        // }
        this.filterVals = col.filterVals;
      }

      // sort filterVals: string first, then numbers, then null/undefined last
      this.filterVals?.sort((a: any, b: any) => {
        // Handle null/undefined values - push to end
        if (a.name == null && b.name == null) return 0;
        if (a.name == null) return 1;  // a goes after b
        if (b.name == null) return -1; // b goes after a
        
        // Check if values are numeric (including numeric strings like '1234')
        const aIsNumeric = typeof a.name === 'number' || 
                          (typeof a.name === 'string' && a.name.trim() !== '' && !isNaN(Number(a.name)));
        const bIsNumeric = typeof b.name === 'number' || 
                          (typeof b.name === 'string' && b.name.trim() !== '' && !isNaN(Number(b.name)));
        
        // Both are numeric (including numeric strings) - compare as numbers
        if (aIsNumeric && bIsNumeric) {
          return Number(a.name) - Number(b.name);
        }
        
        // Both are non-numeric strings - compare alphabetically
        if (!aIsNumeric && !bIsNumeric) {
          return String(a.name).localeCompare(String(b.name));
        }
        
        // Non-numeric string comes before numeric
        if (!aIsNumeric && bIsNumeric) return -1;
        if (aIsNumeric && !bIsNumeric) return 1;
        
        // Fallback
        return 0;
      });
      //console.log("this.filterVals", this.filterVals);
    }

    if(this.filterVals?.length==0 || (this.filterVals?.length == 1 && this.filterVals?.[0]?.name=='' || this.filterVals?.[0]?.name==null)){
      this.noData = true;
    }

    this.addSelectedColumnValues();
    // this.cdr.detectChanges();
  }
  ngAfterContentChecked() {
    //your code to update the model
    this.cdr.detectChanges();
  }

  applyFilter() {
    for (const val of this.filterVals) {
      val.checked = false;
    }
    for (const val of this.filterVals) {
      for (const selectedVal of this.form.value['filters']) {
        // Compare with null if val.name is empty, otherwise compare with val.name
        const valToCompare = val.name ?? "";
        // Use loose equality to handle both string and number comparisons
        if (selectedVal == valToCompare || String(selectedVal) === String(valToCompare)) {
          val.checked = true;
        }
      }
    }

    // Update only the current column's filterVals
    for (const col of this.cols) {
      if (col.name === this.colName) {
        col.filterVals = this.filterVals;
      }
    }
    this.event.emit({ data: this.cols });
    this.bsModalRef.hide();
  }

  clearFilter() {
    // Clear only the current column's filter values
    if(this.filterVals.length > 0) {
      for (const val of this.filterVals) {
        val.checked = false;
      }
    }
    
    // Clear the form controls
    const filters: FormArray = this.form.get('filters') as FormArray;
    while (filters.length !== 0) {
      filters.removeAt(0);
    }
    
    // Delete filterVals only for the current column
    for (const col of this.cols) {
      if (col.name === this.colName) {
        delete col.filterVals;
      }
    }
    
    this.event.emit({ data: this.cols });
    this.bsModalRef.hide();
  }

  addSelectedColumnValues() {
    const filters: FormArray = this.form.get('filters') as FormArray;
    if (this.filterVals) {
      for (const val of this.filterVals) {
        if (val.checked) {
          // Push the actual value (preserve null, numbers, strings)
          const valueToAdd = val.name ?? "";
          filters.push(new FormControl(valueToAdd));
        } else {
          let i: number = 0;
          const valueToRemove = val.name ?? "";
          filters.controls.forEach((item: any) => {
            // Compare both direct and string representations
            if (item.value == valueToRemove || String(item.value) === String(valueToRemove)) {
              filters.removeAt(i);
              return;
            }
            i++;
          });
        }
      }
    }
  }

  onCheckboxChange(e: any) {
    const filters: FormArray = this.form.get('filters') as FormArray;
    if (e.target.checked) {
      // Get the checkbox value and try to parse as number if applicable
      let valueToAdd = e.target.value || "";
      
      // Find the original value from filterVals to preserve its type
      const originalVal = this.filterVals.find((v: any) => 
        String(v.name) === String(valueToAdd)
      );
      if (originalVal) {
        valueToAdd = originalVal.name ?? "";
      }
      
      filters.push(new FormControl(valueToAdd));
    } else {
      let i: number = 0;
      const valueToRemove = e.target.value || "";
      filters.controls.forEach((item: any) => {
        // Compare both direct and string representations
        if (item.value == valueToRemove || String(item.value) === String(valueToRemove)) {
          filters.removeAt(i);
          return;
        }
        i++;
      });
    }
  }
}
